import { REFERRER_DOMAIN_MAP } from '../constants';
import { getFacebookClickIdFromURL } from './getFacebookClickIdFromURL';
import { getGoogleClickIdFromURL } from './getGoogleClickIdFromURL';

const GOOGLE_REFERRER = 'google.com';
const FACEBOOK_REFERRER = 'facebook.com';

const normalizeHostname = (hostname: string): string => hostname.replace(/^www\./, '');

const normalizeReferrerValue = (value: string): string => {
  const trimmedValue = value.trim();

  try {
    if (trimmedValue.includes('://') || trimmedValue.startsWith('//')) {
      const url = trimmedValue.startsWith('//') ? `https:${trimmedValue}` : trimmedValue;

      return normalizeHostname(new URL(url).hostname);
    }
  } catch {
    // fall through to plain domain normalization
  }

  return normalizeHostname(trimmedValue.split('/')[0]);
};

const getReferrerFromDocument = (): string | undefined => {
  if (!document.referrer) {
    return undefined;
  }

  try {
    const referrerHostname = normalizeHostname(new URL(document.referrer).hostname);
    const currentHostname = normalizeHostname(window.location.hostname);

    if (referrerHostname === currentHostname) {
      return undefined;
    }

    return REFERRER_DOMAIN_MAP[referrerHostname] ?? referrerHostname;
  } catch {
    return undefined;
  }
};

export const getReferrerDomain = (): string | undefined => {
  const referrerParam = new URLSearchParams(window.location.search).get('referrer');

  if (referrerParam) {
    return normalizeReferrerValue(referrerParam);
  }

  if (getGoogleClickIdFromURL()) {
    return GOOGLE_REFERRER;
  }

  if (getFacebookClickIdFromURL()) {
    return FACEBOOK_REFERRER;
  }

  return getReferrerFromDocument();
};
